<template>
    <div>
        <headerNotice routerName="添加折扣"></headerNotice>
        <!-- 填写的数据 -->
        <div class="iptData">
            <!-- 数据填写 -->
            <el-form :model="formData" class="signUp_Form" label-width="150px">
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="限时折扣促销名称：" :required="true">
                            <el-input
                                class="inputStyle"
                                v-model="formData.title"
                                placeholder="不能为空，1-20个字符"
                                clearable
                                size="medium"
                                maxlength="20"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="开始时间：" :required="true">
                            <el-date-picker
                                v-model="formData.startTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="8">
                        <el-form-item label="结束时间：" :required="true">
                            <el-date-picker
                                v-model="formData.endTime"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间"
                            ></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="7">
                        <el-form-item label="限购设置：" :required="true">
                            <el-radio-group v-model="formData.limitCount">
                                <el-radio :label="0">不限购</el-radio>
                                <el-radio
                                    :label="formData.limitCount===0?'':formData.limitCount"
                                >每人每种商品限购</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col class="sale" v-if="formData.limitCount!==0" :span="4" :offset="0">
                        <el-input placeholder="请输入数量" type="number" v-model="formData.limitCount">
                            <template slot="append">件</template>
                        </el-input>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col class="sale" :span="20">
                        <el-form-item label="适合的客户：" required>
                            <el-radio-group v-model="formData.customerScope">
                                <el-radio :label="1">全部客户</el-radio>
                                <el-radio :label="2">新客户</el-radio>
                                <el-radio :label="3">老客户</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="row">
                    <el-col :span="6">
                        <el-form-item label="活动范围：" :required="true">
                            <el-radio-group v-model="formData.cityScope">
                                <el-radio :label="1">全部地区</el-radio>
                                <!-- <el-radio :label="2">指定地区</el-radio> -->
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col class="sale" v-if="formData.cityScope==2" :span="4" :offset="0">
                        <el-button type="primary" @click="reginDialogVisible=true">选择地区</el-button>
                        <span>
                            &nbsp;&nbsp;&nbsp;&nbsp;已选择
                            <span
                                style="color:#f63b3b;"
                            >{{formData.cityCodes.length}}</span> 个地区
                        </span>
                    </el-col>
                </el-row>
            </el-form>
            <!-- 表格商品操作 -->
            <div class="chooseAcitveGoods">
                <div class="title">
                    <span>*</span> 选择活动商品：
                </div>
                <el-tabs v-model="activeName" class="tabs">
                    <el-tab-pane label="第一步：选择商品" disabled name="first">
                        <!-- 搜索栏 -->
                        <div class="searchBox">
                            <el-row :gutter="24">
                                <!-- 搜索框 -->
                                <el-col :span="5" :offset="0">
                                    <el-input placeholder="请输入商品名称" v-model="serachForm.word"></el-input>
                                </el-col>
                                <!-- 分类搜索 -->
                                <el-col :span="4" :offset="0">
                                    <el-select v-model="serachForm.cateID" placeholder="请选择分类">
                                        <el-option label="全部" :value="0"></el-option>
                                        <el-option
                                            v-for="item in cateList"
                                            :key="item.cateID"
                                            :label="item.cateName"
                                            :value="item.cateID"
                                        ></el-option>
                                    </el-select>
                                </el-col>
                                <!-- 标签搜索 -->
                                <el-col :span="4" :offset="0">
                                    <el-select v-model="serachForm.labelID" placeholder="请选择商品标签">
                                        <el-option label="全部" :value="0"></el-option>
                                        <el-option
                                            v-for="item in labelList"
                                            :key="item.labelID"
                                            :label="item.labelName"
                                            :value="item.labelID"
                                        ></el-option>
                                    </el-select>
                                </el-col>

                                <el-col :span="2" :offset="0">
                                    <el-button type="primary" @click="goodsStartSearch">查询</el-button>
                                </el-col>
                            </el-row>
                        </div>
                        <el-table
                            class="tableBox"
                            :data="goodsList"
                            style="width: 100%"
                            :default-sort="{prop: 'date', order: 'descending'}"
                            ref="multipleTable"
                            @selection-change="handleGoodsChange"
                            v-loading="loading"
                        >
                            <el-table-column type="selection" :selectable="isCanChoose" width="55"></el-table-column>
                            <el-table-column
                                align="center"
                                prop="customer"
                                label="商品图片"
                                width="120"
                            >
                                <template slot-scope="scope">
                                    <img
                                        :src="baseUrl+scope.row.imgUrl"
                                        width="100"
                                        height="100"
                                        alt
                                    >
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="title" label="商品名称"></el-table-column>
                            <!-- <el-table-column align="center" prop="propName" label="规格"></el-table-column>
                            <el-table-column align="center" prop="propCode" label="规格编号"></el-table-column>
                            <el-table-column align="center" prop="price" label="销售价（￥）"></el-table-column> -->
                            <el-table-column align="center" prop="itemCode" label="商品编号"></el-table-column>
                            <el-table-column align="center" label="操作" width="250">
                                <template slot-scope="scope">
                                    <el-button
                                        v-if="!scope.row.checked"
                                        @click="joinDiscount(scope.row,scope.$index)"
                                        type="primary"
                                        size="small"
                                    >参加折扣</el-button>
                                    <el-button
                                        disabled
                                        v-if="scope.row.checked"
                                        type="info"
                                        size="small"
                                    >已参加</el-button>
                                    <el-button
                                        v-if="scope.row.checked"
                                        @click="cancelFirstJoin(scope.row,scope.$index)"
                                        type="danger"
                                        size="small"
                                    >取消参加</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--分页-->
                        <el-pagination
                            class="pagination"
                            @size-change="handleGoodsSizeChange"
                            @current-change="handleGoodsCurrentChange"
                            :page-sizes="[10, 20, 30, 40]"
                            layout="total, sizes, next"
                            :background="true"
                            next-text="点击加载更多⇣⇣"
                            :total="goodsTotalCount"
                        ></el-pagination>
                        <!-- 多选操作 -->
                        <div style="margin-top: 20px">
                            <el-button type="success" @click="choosedJoinDiscount">批量参加折扣</el-button>
                        </div>
                        <div style="text-align:center;margin-bottom:20px;">
                            <el-button type="primary" @click="nextStep">下一步</el-button>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane disabled label="第二部：设置折扣" name="second">
                        <div class="fastHandle">
                            <el-row :gutter="24" class="row">
                                <el-col :span="4" :offset="0">
                                    <el-radio-group v-model="allDiscountType">
                                        <el-radio :label="1">全部打折</el-radio>
                                        <el-radio :label="2">全部减价</el-radio>
                                    </el-radio-group>
                                </el-col>
                                <el-col :span="3" :offset="0">
                                    <el-input placeholder="请输入" v-model="allDiscountVal">
                                        <template slot="append">{{allDiscountType==1?'折':'元'}}</template>
                                    </el-input>
                                </el-col>
                                <el-col :span="2" :offset="0">
                                    <el-button type="primary" @click="allItemsHandleDiscount">确定</el-button>
                                </el-col>
                                <el-col :span="1" :offset="0">
                                    <el-tooltip
                                        class="item"
                                        effect="dark"
                                        content
                                        placement="bottom"
                                    >
                                        <div slot="content">使用『全部打折』或『全部减价』批量设置后，
                                            <br>你还可以单独调整每个商品的折扣和减价，
                                            <br>也可以直接填写期望的价格。
                                        </div>
                                        <i style="cursor:pointer;" class="el-icon-info"></i>
                                    </el-tooltip>
                                </el-col>
                                <el-col :span="5" :offset="2">
                                    <el-radio-group
                                        v-model="clearToFixed"
                                        @change="clearFixedChange"
                                    >
                                        <el-radio :label="null">取消</el-radio>
                                        <el-radio :label="2">抹去角和分</el-radio>
                                        <el-radio :label="1">抹去分</el-radio>
                                    </el-radio-group>
                                </el-col>

                                <el-col :span="1" :offset="0">
                                    <el-tooltip class="item" effect="dark" placement="bottom">
                                        <div slot="content">抹零是指付钱时不计整数以外的尾数；
                                            <br>抹零对折后价低于1.00元的商品无效。
                                        </div>
                                        <i style="cursor:pointer;" class="el-icon-info"></i>
                                    </el-tooltip>
                                </el-col>
                            </el-row>
                            <el-table
                                class="tableBox"
                                :data="oneStepLastGoods"
                                style="width: 100%"
                                :default-sort="{prop: 'date', order: 'descending'}"
                                ref="multipleTable"
                                @selection-change="handleSettedGoodsChange"
                                v-loading="loading"
                            >
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column
                                    align="center"
                                    prop="customer"
                                    label="商品图片"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <img
                                            :src="baseUrl+scope.row.imgUrl"
                                            width="100"
                                            height="100"
                                            alt
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column prop="userID" label="商品名称">
                                    <template slot-scope="scope">
                                        <div class="goodsInfo">
                                            <span>
                                                品牌名称：
                                                <span style="color:#999;">{{scope.row.title}}</span>
                                            </span>
                                        </div>
                                        <div class="goodsInfo">
                                            <!-- <span>规格名称：{{scope.row.propName}}</span> -->
                                        </div>
                                        <div class="goodsInfo">
                                            <span>价格：{{scope.row.price}}</span>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    align="center"
                                    class-name="handleTr"
                                    label="操作"
                                    width="800"
                                >
                                    <template slot-scope="scope">
                                        <el-row>
                                            <el-col :span="6">
                                                <el-input
                                                    placeholder="请输入折扣"
                                                    size="small"
                                                    type="number"
                                                    v-model="scope.row.discount"
                                                    @change="isOverMaxOrLowerThanMin(0,10,scope.$index,1)"
                                                    :disabled="scope.row.rebate>0"
                                                >
                                                    <template class="slotBtn" slot="prepend">打折</template>
                                                    <template slot="append">折</template>
                                                </el-input>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-input
                                                    placeholder="请输入价格"
                                                    size="small"
                                                    type="number"
                                                    v-model="scope.row.rebate"
                                                    @change="isOverMaxOrLowerThanMin(0,scope.row.price,scope.$index,2)"
                                                    :disabled="scope.row.discount>0"
                                                >
                                                    <template slot="prepend">减价</template>
                                                    <template slot="append">元</template>
                                                </el-input>
                                            </el-col>
                                            <el-col :span="6">
                                                <el-input
                                                    placeholder="请输入价格"
                                                    size="small"
                                                    type="number"
                                                    v-model="scope.row.discountPrice"
                                                    @change="isOverMaxOrLowerThanMin(0,scope.row.price,scope.$index,3)"
                                                >
                                                    <template slot="prepend">打折后</template>
                                                    <template slot="append">元</template>
                                                </el-input>
                                            </el-col>
                                            <el-col :span="2">
                                                <el-button
                                                    size="small"
                                                    type="danger"
                                                    @click="cancelSecondJoin(scope.row,scope.$index)"
                                                >取消参与</el-button>
                                            </el-col>
                                        </el-row>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 多选操作 -->
                            <div style="margin-top: 20px">
                                <el-button type="danger" @click="choosedCancelDiscount">批量取消参与</el-button>
                            </div>
                            <div style="text-align:center;margin-bottom:20px;">
                                <el-button type="primary" @click="preStep">上一步</el-button>
                            </div>
                            <!--分页-->
                            <el-pagination
                                class="pagination"
                                layout="total"
                                :total="oneStepLastGoods.length"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!-- 选择区域dialog框 -->
            <el-dialog
                title="请选择活动范围区域"
                class="shieldDialog"
                :visible.sync="reginDialogVisible"
                width="30%"
            >
                <el-tree
                    v-loading="dialogLoading"
                    :data="reginData"
                    show-checkbox
                    node-key="code"
                    :default-checked-keys="defaultKeys"
                    accordion
                    :props="defaultProps"
                    ref="reginTree"
                ></el-tree>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="reginDialogVisible = false">取 消</el-button>
                    <el-button type="primary" :loading="btnLoading" @click="dialogConfirmData">确 定</el-button>
                </span>
            </el-dialog>
            <!-- 保存按钮 -->
            <div style="text-align:center;">
                <el-button type="info" @click="cancel">返回</el-button>
                <el-button type="primary" :loading="btnLoading" @click="saveData">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            baseUrl: this.$store.state.apiUrl,
            loading: false,
            formData: {
                "title": "",
                "startTime": "",
                "endTime": "",
                "limitCount": 0,
                "customerScope": 1,
                "cityScope": 1,
                "cityCodes": [],
                "itemPropList": []
            },
            activeName: 'first',
            goodsTotalCount: 0,//商品总数据条数
            maxResultCount: 10, //默认一页显示的个数,
            cateList: [],//所有分类数据
            labelList: [],//所有变标签数据
            reginData: [],//所有区域数据
            defaultProps: {
                children: 'children',
                label: 'name'
            },
            defaultKeys: [],//默认已勾选的区域
            reginDialogVisible: false,
            dialogLoading: false,
            btnLoading: false,
            goodsList: [],//第一步商品列表
            serachForm: {//高级搜索弹框数据
                'word': '',
                'cateID': null,
                'labelID': null,
            },
            singleJoinItem: [],//第一步 右边 单个 点击参加的 商品
            choosedGoodsItem: [],//第一步 已经 勾选 的商品
            choosedJoinGoodsItem: [],//第一步 已经 勾选 要参加 的商品
            oneStepLastGoods: [],//第一步 去重  勾选等 处理完 最终的商品数组  即第二步的商品列表数组
            canIChooseTab: true,//是否能点击第二步
            allDiscountType: 1,//1全部打折 2全部减价
            allDiscountVal: '',//全部打的折扣 或者减的价格
            secondChooseGoods: [],//第二步选择的商品
            // secondMaxResultCount:2,//第二步一页显示多少个
            clearToFixed: null//抹去角和分 2   抹去角1
        }
    },
    components: {
        headerNotice,
    },
    mounted() {
        this.getSelectDatas();
        this.getAllRegin();
        this.getGoodsListData({
            MaxResultCount: this.maxResultCount
        })
    },
    methods: {
        //获取所有分类下拉
        getSelectDatas() {
            let self = this;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminItem/GetCLUBList",
                success(res) {
                    self.cateList = res.cateList;
                    self.labelList = res.labelList;
                },
                fail(res) {
                }
            })
        },
        //获取所有省市数据
        getAllRegin() {
            let self = this;
            self.dialogLoading = true;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSale/GetProvinceList",
                success(res) {
                    self.reginData = res;
                    self.reginDialogVisible = false;
                    self.dialogLoading = false;
                    self.btnLoading = false;
                },
                fail(res) {
                    self.dialogLoading = false;
                    self.btnLoading = false;
                }
            })
        },
        //获取第一步中的商品列表
        getGoodsListData(params, isSearch) {
            let self = this;
            self.loading = true;
            //获取分类
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSale/GetItemPropList",
                params: params,
                success(res) {
                    if (isSearch) {
                        self.goodsList = res.items;
                    } else {
                        self.goodsList = self.goodsList.concat(res.items);
                    }
                    self.oneStepLastGoods.forEach((ele1, index1) => {
                        self.goodsList.forEach((ele2, index2) => {
                            if (ele1.itemID == ele2.itemID) {
                                self.goodsList[index2].checked = true;
                            }
                        })
                    })
                    self.goodsTotalCount = res.totalCount;
                    self.$forceUpdate();
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        // 第一步 table开始搜索
        goodsStartSearch() {
            this.serachForm.MaxResultCount = this.maxResultCount;
            this.serachForm.SkipCount = 0;
            this.getGoodsListData(this.serachForm, 1);
        },
        //区域选择dialog框 的确定按钮
        dialogConfirmData() {
            this.formData.cityCodes = this.$refs.reginTree.getCheckedKeys();
            this.reginDialogVisible = false;
        },
        //第一步 操作 参加折扣
        joinDiscount(row, index) {
            this.singleJoinItem.push(row);
            let flag = true;
            //判断最后一步的数组里是否有跟现在点击参与活动的商品有相同的itemID
            this.oneStepLastGoods.forEach((ele, index) => {
                if (ele.itemID == row.itemID) {
                    flag = false;
                }
            })
            //如果没有相同 就push
            if (flag) {
                this.oneStepLastGoods.push(row);
            }
            this.goodsList[index].checked = true;
        },
        //已经参加的 禁止勾选
        isCanChoose(row, index) {
            if (row.checked) {
                return false
            } else {
                return true
            }
        },
        //第一步 批量 选择商品
        handleGoodsChange(val) {
            this.choosedGoodsItem = val;
        },
        //取消第一步的参与的折扣
        cancelFirstJoin(row, index) {
            this.goodsList[index].checked = false;
        },
        //批量勾选参加折扣
        choosedJoinDiscount(row) {
            //让勾选的商品checked = true  即参加活动
            this.choosedGoodsItem.forEach((ele, index) => {
                ele.checked = true;
            })
            //单个参与的数组与 勾选的数组合并
            let addArr = this.singleJoinItem.concat(this.choosedGoodsItem);
            addArr = addArr.concat(this.oneStepLastGoods);
            //去重   方法 详见 assets/js/common.js 中的 reduceSameOneArr()
            addArr = $commonFn.reduceSameOneArr(addArr, 'itemID');
            // 如果某个商品取消了参与  则把checked = false 商品的移除  因为splice一条数据 addArr.length遍历时减1所以最后i--
            for (let i = 0; i < addArr.length; i++) {
                if (!addArr[i].checked) {
                    addArr.splice(i, 1);
                    i--;
                }
            }
            this.oneStepLastGoods = addArr;
        },
        //下一步
        nextStep() {
            let self = this;
            //先判断是否有checked = false 商品 有就去掉
            for (let i = 0; i < this.oneStepLastGoods.length; i++) {
                if (!this.oneStepLastGoods[i].checked) {
                    this.oneStepLastGoods.splice(i, 1);
                    i--;
                }
            }
            if (!this.oneStepLastGoods.length) {
                this.$message.error('对不起，您未选择参加活动的商品');
                return;
            } else {
                this.activeName = 'second';
            }
        },
        //上一步
        preStep() {
            this.activeName = 'first';
        },
        //第二步  确认全部折扣
        allItemsHandleDiscount() {
            let self = this;
            //全部打折
            if (this.allDiscountType == 1) {
                if (this.allDiscountVal > 10) {
                    this.$message.error('最大折扣不能超过10折');
                    return
                } else {
                    this.oneStepLastGoods.forEach((ele, index) => {
                        ele.discount = self.allDiscountVal;
                        ele.rebate = 0;
                        ele.discountPrice = ele.discount * ele.price * 0.1;
                    })
                }
            } else {
                let flag = true;
                this.oneStepLastGoods.forEach((ele, index) => {
                    //如果输入减价的值大于所有商品单价的最大值  则falg = false
                    if (self.allDiscountVal > ele.price) {
                        flag = false;
                    }
                })
                if (flag) {
                    this.oneStepLastGoods.forEach((ele, index) => {
                        //如果输入减价的值大于所有商品单价的最大值  则falg = false
                        ele.discount = 0;
                        ele.rebate = self.allDiscountVal;
                        ele.discountPrice = ele.price - self.allDiscountVal;
                    })
                } else {
                    this.$message.error('减价的价格不能低于某个商品单价！');
                }
            }
        },
        //第二步 抹去角或者分
        clearFixedChange(val) {
            let self = this;
            this.oneStepLastGoods.forEach((ele, index) => {
                let discountPrice = ele.discountPrice;
                discountPrice = Number(discountPrice);
                discountPrice = discountPrice.toFixed(val == 2 ? 0 : 1);
                ele.discountPrice = Number(discountPrice);
            })
        },
        //第二步 判断输入值是否大于或者小于输入框的最大值以及最小值  然后给对应的输入框进行关联
        isOverMaxOrLowerThanMin(min, max, index, ways) {
            //折扣
            if (ways == 1) {
                if (this.oneStepLastGoods[index].discount < min) {
                    this.$message.error('折扣不能低于0折');
                    this.oneStepLastGoods[index].discount = 0;
                } else if (this.oneStepLastGoods[index].discount > max) {
                    this.$message.error('折扣不能大于' + max + '折');
                    this.oneStepLastGoods[index].discount = 0;
                } else {
                    this.oneStepLastGoods[index].rebate = 0;//修改折扣后让减价为0
                    let price = this.oneStepLastGoods[index].price;//原价
                    let editDiscount = this.oneStepLastGoods[index].discount; //修改后 的折扣
                    let editDiscountPrice = this.oneStepLastGoods[index].discountPrice;//最终价格
                    editDiscountPrice = editDiscount * 0.1 * price;
                    this.oneStepLastGoods[index].discountPrice = Number(editDiscountPrice.toFixed(2));//修改后的最终价格
                }
            }
            if (ways == 2) {
                if (this.oneStepLastGoods[index].rebate < min) {
                    this.$message.error('减价不能低于' + min + '元');
                    this.oneStepLastGoods[index].rebate = 0;
                } else if (this.oneStepLastGoods[index].rebate > max) {
                    this.$message.error('减价大于能低于' + max + '元');
                    this.oneStepLastGoods[index].rebate = 0;
                } else {
                    this.oneStepLastGoods[index].discount = 0;//修改折扣后让折扣为0
                    let price = this.oneStepLastGoods[index].price;//原价
                    let editRebate = this.oneStepLastGoods[index].rebate; //修改后的减价
                    this.oneStepLastGoods[index].discountPrice = Number(price - editRebate);//修改后的最终价格
                }
            }
            if (ways == 3) {
                if (this.oneStepLastGoods[index].discountPrice < min) {
                    this.$message.error('减价不能低于' + min + '元');
                    this.oneStepLastGoods[index].discountPrice = 0;
                } else if (this.oneStepLastGoods[index].discountPrice > max) {
                    this.$message.error('减价大于能低于' + max + '元');
                    this.oneStepLastGoods[index].discountPrice = 0;
                } else {
                    this.oneStepLastGoods[index].rebate = 0;//修改折扣后让减价为0
                    let editDiscountPrice = this.oneStepLastGoods[index].discountPrice;//修改后的最终价格
                    let price = this.oneStepLastGoods[index].price;//原价
                    let editDiscount = editDiscountPrice / price; //修改后 的折扣
                    this.oneStepLastGoods[index].discount = Number((editDiscount * 10).toFixed(2));//修改后的最终折扣
                }
            }
        },
        //第二步 选择的商品
        handleSettedGoodsChange(val) {
            this.secondChooseGoods = val;
        },
        //取消第二步的参与的折扣
        cancelSecondJoin(row, index) {
            this.$confirm('确定取消该商品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.oneStepLastGoods[index].checked = false;
                this.oneStepLastGoods.splice(index, 1);
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {


            });
        },
        //批量勾选取消参与折扣
        choosedCancelDiscount() {
            this.$confirm('确定取消已选择的商品的优惠活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.secondChooseGoods.forEach((ele, index) => {
                    this.secondChooseGoods[index].checked = false;
                })
                //去除相同itemID相同的两个商品
                //方法 详见 assets/js/common.js 中的 reduceSameTwoArr()
                this.oneStepLastGoods = $commonFn.reduceSameTwoArr(this.oneStepLastGoods, this.secondChooseGoods, 'itemID');
                this.$forceUpdate();
                this.$message({
                    type: 'success',
                    message: '取消成功!'
                });
            }).catch(() => {

                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });

        },
        //第一步 一页显示多少个
        handleGoodsSizeChange(val) {
            this.maxResultCount = val;
            let params = {
                MaxResultCount: val,
                SkipCount: 0,
            };
            this.goodsList = [];
            this.singleJoinItem = [];
            this.choosedJoinGoodsItem = [];
            this.oneStepLastGoods = [];
            this.secondChooseGoods = [];
            this.getGoodsListData(params, 0);
        },
        //第一步 跳转到指定页
        handleGoodsCurrentChange(val) {
            this.loading = true;
            let skipCount = (val - 1) * this.maxResultCount;
            let params = this.serachForm;
            params.MaxResultCount = this.maxResultCount;
            params.SkipCount = skipCount;
            this.getGoodsListData(params, 0);
        },
        //返回
        cancel() {
            this.$router.back();
        },
        //保存数据
        saveData() {
            let self = this;
            self.btnLoading = true;
            if (!this.oneStepLastGoods.length) {
                this.$message.error('请选择优惠的商品！');
                self.btnLoading = false;
                return;
            }
            this.formData.itemPropList = this.oneStepLastGoods;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminSale/Create",
                data: this.formData,
                success(res) {
                    self.$message({
                        type: 'success',
                        message: '添加成功!'
                    });
                    let timer = setTimeout(() => {
                        self.btnLoading = false;
                        self.$router.back();
                        clearTimeout(timer)
                    }, 1000);

                },
                fail(res) {
                    self.btnLoading = false;
                }
            })
        },
    }
}
</script>

<style lang='scss' scoped>
//填写的数据
.iptData {
    padding: 20px 50px;
    .chooseAcitveGoods {
        .title {
            width: 140px;
            font-size: 14px;
            text-align: right;
            padding-right: 10px;
            color: #606266;
            span {
                color: #f63b3b;
            }
        }

        .tabs {
            padding: 20px 50px;
            .searchBox {
                padding-top: 20px;
            }
            .tableBox {
                margin-top: 20px;
                border: 1px solid #c5c5c5;
                /deep/ .handleTr .cell .el-row {
                    display: flex;
                    justify-content: space-between;
                    input {
                        padding: 0 5px;
                        text-align: center;
                    }
                    .el-input-group__prepend {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                    .el-input-group__append {
                        padding-left: 10px;
                        padding-right: 10px;
                    }
                }
            }
            .fastHandle {
                padding: 20px 0;
                .row {
                    display: flex;
                    align-items: center;
                }
            }
            /deep/ .el-tabs__item.is-disabled {
                color: #333;
            }
            /deep/ .pagination {
                .btn-next {
                    background: #eee;
                    color: #333;
                    padding: 0 10px;
                    border-radius: 4px;
                    border: 1px solid #c5c5c5;
                }
            }
        }
    }
}
</style>